import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { employmentSelector } from '../selectors'
import { handleRequestError } from './request'
import { updateAndSaveActiveTaxReturn } from './tax-return'

export const REQUEST_EMPLOYMENT_SUMMARY = 'REQUEST_EMPLOYMENT_SUMMARY'
export const RECEIVE_EMPLOYMENT_SUMMARY = 'RECEIVE_EMPLOYMENT_SUMMARY'
export const SAVE_EMPLOYMENT_SUMMARY = 'SAVE_EMPLOYMENT_SUMMARY'
const CREATE_EMPLOYMENT_SUMMARY = 'CREATE_EMPLOYMENT_SUMMARY'

export const requestEmploymentSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_EMPLOYMENT_SUMMARY, data: { taxReturnId } })

    axios
        .get(`/employmentsummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveEmploymentSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveEmploymentSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveEmploymentSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveEmploymentSummary = (data) => ({ type: RECEIVE_EMPLOYMENT_SUMMARY, data })

export const saveEmploymentSummary = (data) => (dispatch) => {
    dispatch({ type: SAVE_EMPLOYMENT_SUMMARY, data })

    const { taxReturnId } = data

    return axios
        .put(`/employmentsummaries/${taxReturnId}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveEmploymentSummary(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSaveEmploymentSummary = (data) => (dispatch, getState) => {
    const { employmentSummary } = employmentSelector(getState())
    const updatedEmploymentSummary = { ...employmentSummary, ...data }

    dispatch(receiveEmploymentSummary(updatedEmploymentSummary))
    return dispatch(saveEmploymentSummary(updatedEmploymentSummary)).catch(() => {})
}

export const updateAndSaveEmploymentSummaryStatus =
    ({ status }) =>
    (dispatch, getState) => {
        const { employmentSummary } = employmentSelector(getState())
        const updatedEmploymentSummary = { ...employmentSummary, status }

        dispatch(receiveEmploymentSummary(updatedEmploymentSummary))
        return dispatch(saveEmploymentSummary(updatedEmploymentSummary))
            .then(() => dispatch(updateAndSaveActiveTaxReturn({ employmentSummaryStatus: status })))
            .catch(() => {})
    }

export const createEmploymentSummary =
    (data = {}) =>
    (dispatch, getState) => {
        const { id } = getState().taxReturn

        dispatch({ type: CREATE_EMPLOYMENT_SUMMARY })

        return axios
            .put(`/employmentsummaries/${id}`, data)
            .then((response) => {
                const responseData = response?.data || {}
                dispatch(receiveEmploymentSummary(responseData))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const createOrUpdateEmploymentSummary = (data) => (dispatch, getState) => {
    const { employmentSummary, hasEmploymentSummary } = employmentSelector(getState())

    const persist = hasEmploymentSummary ? updateAndSaveEmploymentSummary : createEmploymentSummary
    return dispatch(persist({ ...employmentSummary, ...data }))
}
